import React from "react";

const EnrollNowButton = ({ 
  text = "Enroll Now", 
  link = "https://shop.bkash.com/jk-associatesrm53807/paymentlink/default-payment", 
  bgColor = "#ffc107", 
  textColor = "#0d6efd" 
}) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          padding: "18px 36px",
          borderRadius: "10px",
          backgroundColor: bgColor,
          color: textColor,
          fontWeight: 700,
          textDecoration: "none",
          fontSize: "20px",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#0d6efd"; // hover blue
          e.currentTarget.style.color = "#fff"; // hover text white
          e.currentTarget.style.transform = "scale(1.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = bgColor;
          e.currentTarget.style.color = textColor;
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        {text}
      </a>
    </div>
  );
};

export default EnrollNowButton;
